export type ViewType =
  | 'DEFAULT_VIEW'
  | 'PLAYLIST_VIEW'
  | 'TRACK_VIEW'
  | 'ALBUM_VIEW'
  | 'ARTIST_VIEW'
  | 'BRIEF_ALL_VIEW'
  | 'BRIEF_INBOX_VIEW'
  | 'BRIEF_OPEN_VIEW'
  | 'BRIEF_CLOSED_VIEW'
  | 'BRIEF_MINE_VIEW'

export const paneViewTypes: ViewType[] = [
  'DEFAULT_VIEW',
  'PLAYLIST_VIEW',
  'TRACK_VIEW',
  'ALBUM_VIEW',
  'ARTIST_VIEW',
]
export const DEFAULT_VIEW = 'DEFAULT_VIEW'
export const PLAYLIST_VIEW = 'PLAYLIST_VIEW'
export const TRACK_VIEW = 'TRACK_VIEW'
export const ALBUM_VIEW = 'ALBUM_VIEW'
export const ARTIST_VIEW = 'ARTIST_VIEW'
export const VIEW_NAMES = {
  [PLAYLIST_VIEW]: 'playlist',
  [ALBUM_VIEW]: 'album',
  [ARTIST_VIEW]: 'artist',
  [TRACK_VIEW]: 'track',
}
export const BRIEF_ALL_VIEW = 'BRIEF_ALL_VIEW'
export const BRIEF_INBOX_VIEW = 'BRIEF_INBOX_VIEW'
export const BRIEF_OPEN_VIEW = 'BRIEF_OPEN_VIEW'
export const BRIEF_CLOSED_VIEW = 'BRIEF_CLOSED_VIEW'
export const BRIEF_MINE_VIEW = 'BRIEF_MINE_VIEW'
export const BRIEF_VIEWS = [
  BRIEF_ALL_VIEW,
  BRIEF_OPEN_VIEW,
  BRIEF_CLOSED_VIEW,
  BRIEF_MINE_VIEW,
]

export const TRACKLESS_VIEWS = [
  PLAYLIST_VIEW,
  ALBUM_VIEW,
  ARTIST_VIEW,
  BRIEF_ALL_VIEW,
  BRIEF_INBOX_VIEW,
  ...BRIEF_VIEWS,
]
